import { useMemo } from 'react';
import DATA_SENSITIVITY_LEVELS from 'client/utils/constants/dataSensitivityLevels';
import { HIDDEN_ASSETS_CATEGORY } from '../constants';

const useAssetOwnerCategories = ({ owner, sensitiveAssets, hierarchy, mapLayers, allAssets, selectedAssetCategory }) => {
    const redactedAssets = useMemo(() => {
        return sensitiveAssets.filter(asset => {
            if (asset?.dataproviderid_fk !== owner?.dataProviderId) {
                return false;
            }

            return asset?.datasensitivitylevel === DATA_SENSITIVITY_LEVELS.REQUIRES_REDACTION;
        });
    }, [owner?.dataProviderId, sensitiveAssets]);

    const categoriesForOwner = useMemo(() => {
        if (!hierarchy?.children || !mapLayers) {
            return [];
        }

        const categories = hierarchy.children.flatMap(categoryNode => {
            const assetTypesInCategory = categoryNode
                .leaves()
                .map(layerNode => layerNode.data.assetType)
                .filter(Boolean);

            const matchingAssets = assetTypesInCategory.flatMap(assetType => {
                return (allAssets[assetType] || []).filter(feature => {
                    return feature?.get?.('dataproviderid_fk') === owner.dataProviderId;
                });
            });

            if (matchingAssets.length === 0) {
                return [];
            }

            return [{
                id: categoryNode.data.name.en,
                category: categoryNode.data.name,
                assetTypes: assetTypesInCategory,
                count: matchingAssets.length
            }];
        });

        if (redactedAssets.length > 0) {
            categories.push({
                id: HIDDEN_ASSETS_CATEGORY,
                category: { en: HIDDEN_ASSETS_CATEGORY },
                labelId: 'isolatedViews.networks.hiddenAssets',
                isHiddenAssetsCategory: true,
                assetTypes: [],
                count: redactedAssets.length
            });
        }

        return categories;
    }, [allAssets, hierarchy, mapLayers, owner?.dataProviderId, redactedAssets]);

    const onlyHasOneCategory = categoriesForOwner.length === 1;
    const hideAllOption = onlyHasOneCategory;
    const effectiveSelectedAssetCategory = onlyHasOneCategory ? categoriesForOwner[0]?.id : selectedAssetCategory;

    return {
        redactedAssets,
        categoriesForOwner,
        onlyHasOneCategory,
        hideAllOption,
        effectiveSelectedAssetCategory
    };
};

export default useAssetOwnerCategories;
